import { mapGetters } from 'vuex';

export default {
    props: [
        'name',
        'id',
        'amount',
        'image',
        'minAmount',
        'sales',
        'countedStock'
    ],

    computed: {
        ...mapGetters({
            promotion: 'promotion/promotion',
        }),
    },

    methods: {
        modalShow() {
            this.$emit('clicked', this.id);
        },
    },
}